import React, { useState, useEffect, useContext } from "react";
import { Store } from "react-notifications-component";
import { Form, Row, Col, Card, Button, Table } from "react-bootstrap";
import DebtPaymentModal from "./Modals/DebtPaymentModal.jsx";
import { AutoComplete, Divider } from "rsuite";
import axios from "axios";
import PermissionContext from "../../Store/permission-context";
import DebtGoodsDetailsModal from "./Modals/DebtGoodsDetailsModal.jsx";
import DebtPaymentHistoryModal from "./Modals/DebtPaymentHistoryModal.jsx";
const ViewDebts = () => {
  const [AxiosError, setAxiosError] = useState("");
  const [Itemname, setItemname] = useState("");
  const [TheDebtor, setTheDebtor] = useState("All");
  const [AllDebts, setAllDebts] = useState([]);
  const [
    AllRegisteredCustomersNames,
    setAllRegisteredCustomersNames,
  ] = useState([]);
  const [AllRegisteredCustomersIDs, setAllRegisteredCustomersIDs] = useState(
    []
  );
  const [showmodal, setshowmodal] = useState(false);
  const [showreceiptmodal, setshowreceiptmodal] = useState(false);
  const [showhistorymodal, setshowhistorymodal] = useState(false);
  const [thedebts, setthedebts] = useState({});
  const [Rct, setRct] = useState({});
  const [PaymentHistory, setPaymentHistory] = useState({});
  const [reload, setreload] = useState(false);
  const PCtx = useContext(PermissionContext);

  useEffect(() => {
    let AllDebtors;
    const getDebts = async () => {
      AllDebtors = await PCtx.connectAxios("getalldebts.php", TheDebtor);

      setAllDebts(AllDebtors);
    };
    getDebts();
  }, [reload, TheDebtor]);

  useEffect(() => {
    const getData = async () => {
      let AllRC = await PCtx.connectAxios("getallregisteredcustomers.php", "");

      let RCN = [];
      let RCID = [];

      AllRC.forEach((element) => {
        RCN.push(element.Names);
        RCID.push(element.IDS);
      });

      setAllRegisteredCustomersNames(RCN);
      setAllRegisteredCustomersIDs(RCID);
    };
    getData();
  }, []);

  const ShowPaymentModal = (dbt) => {
    setthedebts(dbt);
  };

  const getItemnameSelection = (TheCustomer) => {
    TheCustomer != "" ? setTheDebtor(TheCustomer) : setTheDebtor("All");
  };
  const getTypedText = () => {
    let TheCustomer = Itemname.charAt(0).toUpperCase() + Itemname.slice(1);

    if (AllRegisteredCustomersNames.includes(TheCustomer)) {
      getItemnameSelection(TheCustomer);
    } else {
      if (TheCustomer === "") {
        setTheDebtor("");
      }
    }
  };

  const getPaymentHistory = async (e, phis) => {
    e.preventDefault();
    const PHistory = await PCtx.connectAxios("getpaymenthistory.php", phis);
    setPaymentHistory(PHistory);
    setshowhistorymodal(true);
  };
  const cancelModal = () => {
    setshowmodal(false);
  };

  const cancelModalReceipt = () => {
    setshowreceiptmodal(false);
  };
  const cancelModalHistory = () => {
    setshowhistorymodal(false);
    setreload(!reload);
  };

  const getThisReceipt = async (e, recs) => {
    e.preventDefault();

    if (recs.RID != "TOTAL") {
      const rdet = { rid: recs.RID, rdate: recs.DatePaid };
      const RDetails = await PCtx.connectAxios("getreceiptdetails.php", rdet);
      const Receipt = {
        OrderData: RDetails,
        Payable: recs.Payable,
        Customer: recs.Customer,
      };

      if (RDetails.length > 0) {
        setRct(Receipt);
        setshowreceiptmodal(true);
      }
    }
  };

  const saveDebtPayment = async (newpayment) => {
    let DebtPayment = await PCtx.connectAxios(
      "savedebtpayment.php",
      newpayment
    );
    if (!DebtPayment.includes("Error")) {
      setreload(!reload);
      PCtx.displayAlert("SUCCESS", "The payment was successful", "success");
    } else {
      PCtx.displayAlert(
        "ERROR",
        "The system encountered an error, please contact the administrator",
        "danger"
      );
    }
    setshowmodal(false);
  };

  useEffect(() => {
    if (parseFloat(thedebts.Balance) > 0) {
      setshowmodal(true);
    }
  }, [thedebts]);

  return (
    <Row className="justify-content-around">
      <Col md={12} lg={12} sm={12} xs={12}>
        <Card>
          <Card.Body>
            <Divider>
              <h3
                className="text-center"
                style={{ color: "brown", fontFamily: "Times New Roman" }}
              >
                ALL STANDING DEBTS{" "}
                {TheDebtor === "All" || TheDebtor === ""
                  ? ""
                  : "OF " + TheDebtor.toLocaleUpperCase()}
              </h3>
            </Divider>
          </Card.Body>
        </Card>
      </Col>
      <Col md={10} sm={12} xs={12}>
        <Form>
          <Form.Group>
            <Form.Label style={{ color: "brown" }}>Search for</Form.Label>

            <AutoComplete
              data={AllRegisteredCustomersNames}
              value={Itemname.charAt(0).toUpperCase() + Itemname.slice(1)}
              onChange={setItemname}
              onSelect={getItemnameSelection}
              onBlur={getTypedText}
              style={{ border: "1px solid brown" }}
              placeholder="Enter Customer Name to search for"
            />
          </Form.Group>
        </Form>
      </Col>
      <Col md={12} sm={12} xs={12}>
        <Card>
          <Card.Header></Card.Header>
          <Card.Body>
            <Table striped bordered responsive>
              <thead>
                <tr>
                  <td>SN</td>
                  <td>RECEIPT NO</td>
                  <td>DATE_OF_TRANSACTION</td>
                  <td>CUSTOMER'S NAME</td>
                  <td>AMOUNT PAYABLE</td>
                  <td>AMOUNT PAID</td>
                  <td>BALANCE</td>
                  <td>STAFF</td>
                  <td>PAYMENT HISTORY</td>
                  <td>MAKE PAYMENT</td>
                </tr>
              </thead>
              <tbody>
                {AllDebts.map((debt, ind) => (
                  <tr key={ind}>
                    <td>{ind < AllDebts.length - 1 ? ind + 1 : ""}</td>
                    <td>
                      <a href="#" onClick={(e) => getThisReceipt(e, debt)}>
                        {debt.RID}
                      </a>
                    </td>
                    <td>{debt.DatePaid}</td>
                    <td>{debt.Customer}</td>
                    <td>{debt.Payable}</td>
                    <td>{debt.Paid}</td>
                    <td>{debt.Balance}</td>
                    <td>{debt.Staff}</td>
                    <td>
                      {ind < AllDebts.length - 1 && (
                        <a href="#" onClick={(e) => getPaymentHistory(e, debt)}>
                          View History
                        </a>
                      )}
                    </td>
                    <td>
                      {ind < AllDebts.length - 1 && (
                        <Button
                          variant="success"
                          className="btn-sm"
                          onClick={() => ShowPaymentModal(debt)}
                        >
                          Pay
                        </Button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>
      {showmodal && (
        <DebtPaymentModal
          showmodal={showmodal}
          debts={thedebts}
          cancelModal={cancelModal}
          savedebtpayment={saveDebtPayment}
        />
      )}
      {showreceiptmodal && (
        <DebtGoodsDetailsModal
          showreceiptmodal={showreceiptmodal}
          ReceiptDetails={Rct}
          cancelModal={cancelModalReceipt}
        />
      )}
      {showhistorymodal && (
        <DebtPaymentHistoryModal
          showhistorymodal={showhistorymodal}
          PaymentHistory={PaymentHistory}
          cancelModal={cancelModalHistory}
        />
      )}
    </Row>
  );
};

export default ViewDebts;
